import type { DeleteCookieProps } from "./utils/deleteCookie";
import { deleteCookie } from "./utils/deleteCookie";
import type { GetCookieProps } from "./utils/getCookie";
import { getCookie } from "./utils/getCookie";
import type { SetCookieProps } from "./utils/setCookie";
import { setCookie } from "./utils/setCookie";

export const COOKIE_KEY_PREFERRED_THEME = "preferredTheme";

export type DeleteCookieThemeProps = Omit<DeleteCookieProps, "key">;

export const deleteCookieTheme = ({ cookies }: DeleteCookieThemeProps = {}) =>
  deleteCookie({ key: COOKIE_KEY_PREFERRED_THEME, cookies });

export type GetCookieThemeProps = Omit<GetCookieProps, "key">;

export const getCookieTheme = ({ cookies, schema }: GetCookieThemeProps = {}) =>
  getCookie({ key: COOKIE_KEY_PREFERRED_THEME, cookies, schema });

export type SetCookieThemeProps = Omit<SetCookieProps, "key">;

export const setCookieTheme = ({
  cookies,
  value,
  domain,
  options,
}: SetCookieThemeProps) =>
  setCookie({
    key: COOKIE_KEY_PREFERRED_THEME,
    cookies,
    value,
    domain,
    options,
  });
